import React from 'react'
import { Grid } from '@mui/material'
import { useQuery } from 'react-query'
import { Loader } from "@egovernments/digit-ui-react-components"
import { OBPSService } from '../../../../../../../libraries/src/services/elements/OBPS'
import {
	AppDetailsContainer,
	AppDetailsWrapper,
	AppDetailsLabel,
	AppDetailsValue,
	AppDetailsHead,
} from './StyledComponents'

function AppDetails() {
	const tenantId = Digit.ULBService.getCurrentTenantId()

	const fetchApplicationStatsData = async () => {
		return await OBPSService.InboxSearchApplication(tenantId, { udHome: true })
	}

	const { isLoading, error, data } = useQuery('applicationStats', fetchApplicationStatsData)

	if (isLoading) {
		return <Loader />
	}

	if (error) {
		return (
			<div style={{ textAlign: 'center' }}>
				Something went wrong, please try again.
			</div>
		)
	}

	return (
		<AppDetailsWrapper>
			<AppDetailsContainer>
				<AppDetailsHead variant='h3'>Application Details</AppDetailsHead>
				<Grid container spacing={2} justifyContent={'center'} alignItems={'center'}>
					<Grid container columnSpacing={3} rowSpacing={4} item md={12} lg={9}>
						{data.map(({ label, count, action }) => (
							<Grid item key={action} xs={12} sm={6} md={4}>
								<AppDetailsLabel>{label === 'Approved' ? 'Permission Granted' : label}</AppDetailsLabel>
								<AppDetailsValue>{count}</AppDetailsValue>
							</Grid>
						))}
					</Grid>
					<Grid item md={12} lg={3} display={'flex'} justifyContent={'center'} alignItems={'center'}>
						<a href="https://nmanoc.nic.in/" target="_blank" rel="noopener nofollow">
							<img src="https://i.imgur.com/fRAizoN.png" alt="Get your ASI NOC" />
						</a>
					</Grid>
				</Grid>
			</AppDetailsContainer>
		</AppDetailsWrapper>
	)
}

export default AppDetails
